import {Flavor, getStage, Stage} from "@smalox/shared";

/**
 * Returns the domain for a given flavor and stage.
 */
export function getFlavorDomain(flavor: Flavor, stage: Stage): string {
	const stagePrefix = stage === "production" ? "" :
		stage === "localhost" ? "-dev" : `-${stage}`;
	const flavorLower = flavor.toLowerCase();
	const domain = flavor === "SMALOX" ? "smalox.com" : `${flavorLower}.app`;
	return `cloud${stagePrefix}.${domain}`;
}

/**
 * Returns the full URL for a tenant with the given flavor.
 * Preserves the current path after the tenant ID.
 */
export function getFlavorUrl(flavor: Flavor, tenantId: string, currentPath: string): string {
	const stage = getStage();

	// For localhost, stay on localhost but add query param
	if (stage === "localhost") {
		const url = new URL(window.location.href);
		// Clear existing flavor params and add the new one
		url.searchParams.delete("smalox");
		url.searchParams.delete("boxlox");
		url.searchParams.delete("daylox");
		if (flavor !== "SMALOX") {
			url.searchParams.set(flavor.toLowerCase(), "");
		}
		return url.toString();
	}

	const domain = getFlavorDomain(flavor, stage);
	// Extract path after tenant ID
	const pathAfterTenant = currentPath.replace(new RegExp(`^/${tenantId}`), "");
	return `https://${domain}/${tenantId}${pathAfterTenant}`;
}
